export const goalNames = {
  LEAD_GENERATION: "Lead generation",
  LINK_CLICKS: "Link clicks",
} as const;
